<div class="cosmos-cluster-send-email__form">
  <div class="cosmos-cluster-send-email__title-close-wrapper">
    <div class="cosmos-cluster-send-email__title-close-wrapper__title">
      Send Email
    </div>
    <div class="cosmos-cluster-send-email__title-close-wrapper__button">
      <button
        (click)="closeModal()"
        class="cosmos-cluster-send-email__title-close-wrapper__button"
      >
        <mat-icon>
          <span>close</span>
        </mat-icon>
      </button>
    </div>
  </div>
  <form
    [formGroup]="_emailForm"
    (submit)="closeModal(this._emailForm.value.email)"
  >
    <input
      formControlName="email"
      type="email"
      placeholder="Ex. name@example.com"
      class="cosmos-cluster-send-email__form__input"
    >
    <div class="cosmos-cluster-send-email__form__buttons">
      <button
        (click)="closeModal()"
        type="button"
        class="cosmos-cluster-send-email__form__buttons__cancelButton"
      >
        Cancel
      </button>
      <button
        [disabled]="!_emailForm.valid"
        type="submit"
        class="cosmos-cluster-send-email__form__buttons__addButton"
      >
        Send
      </button>
    </div>
  </form>
</div>
